import { render } from "./DepartTree.vue?vue&type=template&id=4cf31458&scoped=true"
import script from "./DepartTree.vue?vue&type=script&lang=js"
export * from "./DepartTree.vue?vue&type=script&lang=js"

import "./DepartTree.vue?vue&type=style&index=0&id=4cf31458&lang=scss&scoped=true"
import "./DepartTree.vue?vue&type=style&index=1&id=4cf31458&lang=scss"

import exportComponent from "/root/workspace/public_sso_ZgiA/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf31458"]])

export default __exports__